import script from "./Extension.vue?vue&type=script&lang=ts&setup=true"
export * from "./Extension.vue?vue&type=script&lang=ts&setup=true"

import "./Extension.vue?vue&type=style&index=0&id=43314432&lang=scss"
import "./Extension.vue?vue&type=style&index=1&id=43314432&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43314432"]])

export default __exports__